export default __webpack_public_path__ + "static/media/330_business02-fr-mobile.11c4d0b5.png";